import { Injectable } from '@angular/core';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';

import { Subject } from 'rxjs';
import { tap } from 'rxjs/operators';
import { ShowDetailClockAbsenceComponent } from './show-detail-clock-absence.component';
import { ShowDetailClockAbsence } from './show-detail-clock-absence.types';

@Injectable({
  providedIn: 'root',
})
export class ShowDetailClockAbsenceService {
  private refreshListSource = new Subject<ShowDetailClockAbsence.Result>();

  refreshList$ = this.refreshListSource.asObservable();

  constructor(private dialog: MatDialog) {}

  open(
    config: MatDialogConfig<ShowDetailClockAbsence.Params> = new MatDialogConfig()
  ) {
    config.disableClose = true;
    const dialogRef = this.dialog.open(ShowDetailClockAbsenceComponent, config);

    return dialogRef.afterClosed().pipe(
      tap((res) => {
        this.refreshListSource.next(res);
      })
    );
  }
}
